export default __webpack_public_path__ + "static/media/home-restaurant-bg-02.149192ab.png";